<template>
  <div class="padres-container">
    <div class="overlay-rosado" />

    <!-- COUNTER -->
    <div ref="contadorRef" class="contador-container">
      <div class="rasgado rasgado-superior"></div>

      <!-- TOP PHRASE (same style as your example) --><br><br>
      <div class="frase-container">
        <h2 ref="fraseLinea1" class="frase linea1">Every second</h2>
        <h2 ref="fraseLinea2" class="frase linea2">closer</h2>
        <p ref="fraseLinea3" class="frase linea3">to my big day!</p>
      </div>

      <!-- TITLE -->
      <div class="contador-titulo">
        <span ref="soloRef" class="solo">Only</span>
        <span ref="faltanRef" class="faltan">Left</span>
      </div>

      <!-- ARROW PNG (falls with a cute bounce) -->
      <div ref="flechaRef" class="flecha-wrapper">
        <img src="@/assets/15.avif" alt="Decorative arrow" class="flecha-img" />
      </div>

      <!-- NUMBERS -->
      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Days</span>
        </div>
        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Hours</span>
        </div>
        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutes</span>
        </div>
        <div ref="tiempoRef4" class="tiempo">
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Seconds</span>
        </div>

        <div class="rasgado rasgado-inferior"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const contadorRef = ref(null)
    const fraseLinea1 = ref(null)
    const fraseLinea2 = ref(null)
    const fraseLinea3 = ref(null)
    const soloRef = ref(null)
    const faltanRef = ref(null)
    const flechaRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-01-03T17:30:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // Estado inicial (caen desde arriba)
      gsap.set(contadorRef.value, { autoAlpha: 0, y: -90 })
      gsap.set([fraseLinea1.value, fraseLinea2.value, fraseLinea3.value], { autoAlpha: 0, y: -50 })
      gsap.set([soloRef.value, faltanRef.value], { autoAlpha: 0, y: -50 })
      gsap.set(flechaRef.value, { autoAlpha: 0, y: -40, scale: 0.85, rotate: -2 })
      gsap.set([tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value], {
        autoAlpha: 0, y: -40
      })

      // Animación al entrar al viewport
      const el = contadorRef.value
      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // Panel principal
          tl.to(el, { autoAlpha: 1, y: 0, duration: 0.9, ease: 'back.out(1.5)' }, 0)

          // Frase (línea 1, 2, 3) consecutiva
          tl.to(fraseLinea1.value, { autoAlpha: 1, y: 0, duration: 0.6 }, '>-0.4')
          tl.to(fraseLinea2.value, { autoAlpha: 1, y: 0, duration: 0.6 }, '>-0.45')
          tl.to(fraseLinea3.value, { autoAlpha: 1, y: 0, duration: 0.6 }, '>-0.45')

          // "Solo" y "Faltan"
          tl.to(soloRef.value,   { autoAlpha: 1, y: 0, duration: 0.6 }, '>-0.35')
          tl.to(faltanRef.value, { autoAlpha: 1, y: 0, duration: 0.6 }, '>-0.35')

          // Flecha (PNG) con rebote suave y brillo leve
          tl.to(flechaRef.value, {
            autoAlpha: 1, y: 0, scale: 1, rotate: 0, duration: 0.9, ease: 'back.out(1.6)'
          }, '>-0.3')

          // Bloques del contador
          tl.to([tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value], {
            autoAlpha: 1, y: 0, duration: 0.55, stagger: 0.12
          }, '>-0.15')

          // Micro “breathing”
          gsap.to(el, { scale: 1.01, duration: 3, repeat: -1, yoyo: true, ease: 'sine.inOut' })
          // Flotación sutil de la flecha
          gsap.to(flechaRef.value, { y: '+=6', duration: 2.2, repeat: -1, yoyo: true, ease: 'sine.inOut', delay: 0.5 })

          io.disconnect()
        })
      }, { threshold: 0.35 })
      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      contadorRef,
      fraseLinea1, fraseLinea2, fraseLinea3,
      soloRef, faltanRef, flechaRef,
      tiempoRef1, tiempoRef2, tiempoRef3, tiempoRef4,
      dias, horas, minutos, segundos
    }
  }
}
</script>

<style scoped>
.padres-container{
  position:relative;
  width:100%;
  min-height:40vh;
  display:flex;
  flex-direction:column;
  align-items:center;
  overflow: visible;
}

.overlay-rosado{
  position:absolute;
  inset:0;
  background:#ffffff !important;
  z-index:0;
}

.contador-container{
  position:relative;
  z-index:2;
  width:100%;
  max-width:600px;
  padding:26px 14px 34px;
  margin-top:20px;
  text-align:center;
  color:#0d0d0d;
background-image: 
  linear-gradient(
    to bottom,
    #d9ecff 0%,
    #b8dcff84 40%,
    #99ccff8f 100%
  ),
  url('@/assets/fndorosa.avif');
  box-shadow:0 12px 32px rgba(0,0,0,.12);
  border-radius:8px;
  opacity:0;
  transform:translateY(50px);
}

/* Frase */
.frase-container{
  margin-top:8px;
  margin-bottom:6px;
}
.frase{
  margin:0;
  color:#1f1e1e;
  font-family:"Playfair Display", serif;
  line-height:1.2;
}
.linea1{ font-size:clamp(20px,3.6vw,28px); font-style:italic; }
.linea2{ font-size:clamp(22px,4.2vw,32px); font-weight:600; }
.linea3{ font-size:clamp(16px,3vw,20px); font-style:italic; color:#503f45; margin-top:6px; }

/* Título "Solo"/"Faltan" */
.contador-titulo{
  margin-top:10px;
  margin-bottom:6px;
}
.contador-titulo .solo{
  font-family:'FeelingPassionate', cursive;
  font-size:32px;
  display:block;
  opacity:0;
}
.contador-titulo .faltan{
  font-family:serif;
  font-size:48px;
  letter-spacing:1px;
  display:block;
  opacity:0;
}

/* Flecha PNG */
.flecha-wrapper{
  display:flex;
  justify-content:center;
  align-items:center;
  height:50px;
padding-top:50px;
  margin: 4px 0 10px;
}
.flecha-img{
  width:30px;
  height:auto;
  opacity:.95;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,.18));
}

/* Números */
.contador-numeros{
  display:flex;
  justify-content:space-around;
  gap:10px;
  padding:4px 8px 12px;
}
.tiempo{
  display:flex;
  flex-direction:column;
  align-items:center;
  opacity:0;
  transform:translateY(50px);
}
.numero{
  font-size:40px;
  font-weight:bold;
  font-family:'Oswald', sans-serif;
}
.etiqueta{
  font-size:14px;
  font-family:'Oswald', sans-serif;
  margin-top:5px;
}

/* Rasgados */
.rasgado{
  position:absolute; left:0; width:100%; height:50px;
  background:#ffffff; z-index:2; pointer-events:none;
}
.rasgado-superior{
  top:0; background:#ffffff;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}
.rasgado-inferior{
  bottom:0;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

/* Responsive */
@media (max-width:420px){
  .contador-numeros{ gap:6px; }
  .numero{ font-size:34px; }
}
</style>
